import React from 'react';

import * as Styled from 'shiftNotes/styles/NotesStack.style';

interface InstantReflexNavigationProps {
  currentStep: number;
  totalSteps: number;
}

export default function InstantReflexNavigation({
  currentStep,
  totalSteps,
}: InstantReflexNavigationProps): JSX.Element {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
  return (
    <Styled.PageIndicatorTrack
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={currentStep}
    >
      {steps.map((step) => (
        <Styled.PageIndicatorPill key={step} $active={step === currentStep} />
      ))}
    </Styled.PageIndicatorTrack>
  );
}
